import StoreTrafficEventsDataViewer from './StoreTrafficEventsDataViewer'
import StoreTrafficQueryHandler from './StoreTrafficQueryHandler'
import StoreTrafficSupportDataViewer from './StoreTrafficSupportDataViewer'

export default {
  install( molten ) {
    molten.addPlugin( 'DataViewer', StoreTrafficSupportDataViewer )
    molten.addPlugin( 'DataViewer', StoreTrafficEventsDataViewer )
    molten.addPlugin( 'EventQueryOptionsHandler', StoreTrafficQueryHandler )
  }
}
